import { IPerson } from './types';

export const personInitialState: IPerson = {
  hasDimoAccount: false,
  person: {
    fullName: '',
    cpf: '',
    email: '',
    phoneNumber: '',
    phoneAreaCode: '',
    address: {
      neighborhood: '',
      street: '',
      number: '',
    },
  },
};
